export default "__VITE_ASSET__Cus2Gqs3__"